/**
 * RoomReadinessIndicator — shared component for room status visual language.
 * ADR §6 — reusable across Housekeeping, Front Office, Reservations.
 *
 * Usage:
 *   <RoomReadinessIndicator status="available" />
 *   <RoomReadinessIndicator status="vacant_dirty" showLabel />
 */
const MAP = {
  available:           { label: "Ready",              tone: "emerald",  bg: "bg-emerald-100",  fg: "text-emerald-800",  dot: "bg-emerald-500" },
  vacant_clean:        { label: "Ready",              tone: "emerald",  bg: "bg-emerald-100",  fg: "text-emerald-800",  dot: "bg-emerald-500" },
  deep_cleaning:       { label: "Cleaning",           tone: "amber",    bg: "bg-amber-100",    fg: "text-amber-900",    dot: "bg-amber-500" },
  in_progress:         { label: "Cleaning",           tone: "amber",    bg: "bg-amber-100",    fg: "text-amber-900",    dot: "bg-amber-500" },
  inspection_pending:  { label: "Waiting Inspection", tone: "orange",   bg: "bg-orange-100",   fg: "text-orange-900",   dot: "bg-orange-500" },
  vacant_dirty:        { label: "Dirty",              tone: "red",      bg: "bg-red-100",      fg: "text-red-800",      dot: "bg-red-500" },
  occupied:            { label: "Occupied",           tone: "blue",     bg: "bg-blue-100",     fg: "text-blue-800",     dot: "bg-blue-500" },
  reserved:            { label: "Reserved",           tone: "blue",     bg: "bg-blue-100",     fg: "text-blue-800",     dot: "bg-blue-500" },
  out_of_service:      { label: "Out of Service",     tone: "gray",     bg: "bg-gray-200",     fg: "text-gray-800",     dot: "bg-gray-700" },
  out_of_order:        { label: "Out of Order",       tone: "gray",     bg: "bg-gray-200",     fg: "text-gray-800",     dot: "bg-gray-700" },
  maintenance:         { label: "Maintenance",        tone: "gray",     bg: "bg-gray-200",     fg: "text-gray-800",     dot: "bg-gray-700" },
  blocked:             { label: "Blocked",            tone: "gray",     bg: "bg-gray-200",     fg: "text-gray-800",     dot: "bg-gray-700" },
};

export function statusMeta(status) {
  return MAP[status] || { label: status || "Unknown", tone: "gray",
                             bg: "bg-gray-100", fg: "text-gray-700", dot: "bg-gray-400" };
}

export default function RoomReadinessIndicator({
  status, showLabel = true, size = "md", className = "", "data-testid": testid,
}) {
  const m = statusMeta(status);
  const sizeCls = size === "sm" ? "text-[11px] px-2 py-0.5" : "text-[12.5px] px-2.5 py-1";
  const dotSize = size === "sm" ? "w-2 h-2" : "w-2.5 h-2.5";
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${m.bg} ${m.fg} ${sizeCls} ${className}`}
      data-testid={testid || `room-readiness-${status}`}
      title={m.label}
    >
      <span className={`inline-block ${dotSize} rounded-full ${m.dot}`} aria-hidden />
      {showLabel && <span className="leading-none">{m.label}</span>}
    </span>
  );
}

export { MAP as READINESS_MAP };
